<template>
  <div class="media-docs-links-panel">
    <el-tabs v-model="activeTab" class="panel-tabs">
      <!-- 影音内容 Tab -->
      <el-tab-pane :label="$t('whatsapp.mediaDocsLinks.tabs.media')" name="media">
        <div class="panel-scroll" @scroll="handleScroll">
          <!-- <div class="group-title">{{ $t('whatsapp.mediaDocsLinks.thisMonth') }}</div> -->
          <div class="media-grid">
            <div
                v-for="item in displayMediaList"
                :key="item._key"
                class="media-grid-item"
                :class="{ selected: isSelected(item._key) }"
            >
              <div class="media-thumb-wrapper">
                <el-checkbox
                    class="media-checkbox"
                    size="small"
                    :model-value="isSelected(item._key)"
                    @change="() => toggleSelect(item._key)"
                    @click.stop
                />
                <img
                    v-if="isImage(item)"
                    class="media-thumb thumb_img"
                    :src="item.url"
                    loading="lazy"
                    decoding="async"
                    @click="handlePreviewMedia(item)"
                />
                <div
                    v-else-if="isVideo(item)"
                    class="media-thumb thumb_video"
                    @click="handlePreviewMedia(item)"
                >
                  <svg class="play_icon" viewBox="0 0 48 48" fill="none">
                    <circle cx="24" cy="24" r="20" fill="rgba(0,0,0,0.5)"/>
                    <path d="M19 14l14 10-14 10V14z" fill="#fff"/>
                  </svg>
                </div>
                <div v-else class="media-thumb thumb_placeholder">
                  <svg viewBox="0 0 48 48" fill="none">
                    <rect x="8" y="12" width="32" height="24" rx="2" fill="#e0e0e0"/>
                    <path d="M8 20l10 8 10-8 12 10v6a2 2 0 01-2 2H10a2 2 0 01-2-2v-6l12-10z" fill="#d0d0d0"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div v-if="pagination.media.loading" class="loading-text">加载中...</div>
          <div v-else-if="!pagination.media.hasMore && displayMediaList.length > 0" class="tip-text">
            {{ $t('whatsapp.mediaDocsLinks.noMoreData') }}
          </div>
          <div v-else-if="displayMediaList.length === 0" class="tip-text">
            {{ $t('whatsapp.mediaDocsLinks.noData') }}
          </div>
          <div style="height: 88px;"></div>
        </div>
      </el-tab-pane>

      <!-- 文档 Tab -->
      <el-tab-pane :label="$t('whatsapp.mediaDocsLinks.tabs.docs')" name="docs">
        <div class="panel-scroll" @scroll="handleScroll">
          <div
              v-for="item in displayDocsList"
              :key="item._key"
              class="doc-row"
          >
            <el-checkbox
                class="doc-row__checkbox"
                :model-value="isSelected(item._key)"
                @change="() => toggleSelect(item._key)"
                @click.stop
            />
            <div
                class="doc-card"
                :class="{ selected: isSelected(item._key) }"
                @dblclick="handlePreviewDoc(item._key)"
            >
            <div style="display: flex;width: 100%;justify-content: space-between;align-items: center;">
                <div class="doc-card__icon">
                  <FileIcon
                      :fileExtend="getFileExtFromNameOrUrl(item?.name || item?.title, item?.url || item?.text)?.toLocaleLowerCase()"
                      :fileUrl="item?.url || item?.text"
                      :size="35"
                      :isAbbreviation="true"
                  ></FileIcon>
                </div>
                <div class="doc-card__main">
                  <div class="doc-card__header">
                    <div class="doc-card__title">{{ item.title }}</div>
                    <!-- <div class="doc-card__sub">{{  }}</div> -->
                  </div>
                  <div class="doc-card__text">{{ (getFileExtFromNameOrUrl(item?.name || item?.title, item?.url || item?.text) || '').toUpperCase() }}·{{ item.sub }}</div>
              
                </div>
                <button
                    class="doc-card__download"
                    type="button"
                    :aria-label="$t('whatsapp.mediaDocsLinks.download')"
                    @click.stop="handleDownload([item._key])"
                >
                  <img style="width: 24px;height: 24px;" src="@/modules/whatsapp/img/down_file.png"/>
                </button>
            </div>
              <div class="doc-card__meta">
                  <!-- <span class="card__time">text</span> -->
                  <span class="doc-card__time">{{  item.createTime }}</span>
                </div>
            </div>
          </div>
          <div v-if="pagination.docs.loading" class="loading-text">加载中...</div>
          <div v-else-if="!pagination.docs.hasMore && displayDocsList.length > 0" class="tip-text">
            {{ $t('whatsapp.mediaDocsLinks.noMoreData') }}
          </div>
          <div v-else-if="displayDocsList.length === 0" class="tip-text">
            {{ $t('whatsapp.mediaDocsLinks.noData') }}
          </div>
          <div style="height: 88px;"></div>
        </div>
      </el-tab-pane>

      <!-- 链接 Tab -->
      <el-tab-pane :label="$t('whatsapp.mediaDocsLinks.tabs.links')" name="links">
        <div class="panel-scroll" @scroll="handleScroll">
          <div
              v-for="item in displayLinksList"
              :key="item._key"
              class="link-row"
          >
            <el-checkbox
                class="link-row__checkbox"
                :model-value="isSelected(item._key)"
                @change="() => toggleSelect(item._key)"
                @click.stop
            />
            <div class="link-content">
              <div
                  class="link-card"
                  :class="{ selected: isSelected(item._key) }"
                  @dblclick.stop="openLinkInNewTab(item)"
              >
                <div style="width: 100%;display: flex;justify-content: space-between">
                  <div class="link-card__icon">
                    <img
                        class="link-favicon"
                        :src="getFaviconUrl(item.text || item.url)"
                        alt=""
                        @error="handleFaviconError"
                    />
                  </div>
                  <div class="link-card__main">
                    <div class="link-card__title">{{ item.title }}</div>
                    <div class="link-card__sub">{{ item.sub }}</div>
                  </div>
                </div>
                <div class="link-text">{{ item.text }}</div>
              </div>

            </div>
          </div>
          <div v-if="pagination.links.loading" class="loading-text">加载中...</div>
          <div v-else-if="!pagination.links.hasMore && displayLinksList.length > 0" class="tip-text">
            {{ $t('whatsapp.mediaDocsLinks.noMoreData') }}
          </div>
          <div v-else-if="displayLinksList.length === 0" class="tip-text">
            {{ $t('whatsapp.mediaDocsLinks.noData') }}
          </div>
          <div style="height: 88px;"></div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 底部操作栏 -->
    <div class="bottom-actions">
      <div class="bottom-actions-main">
        <button class="action-btn" type="button" :aria-label="$t('whatsapp.mediaDocsLinks.delete')" @click="handleDelete()">
          <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/delete.png"/>
        </button>
        <button class="action-btn" type="button" :aria-label="$t('whatsapp.mediaDocsLinks.forward')" @click="handleForward()">
          <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/forword.png"/>
        </button>
        <button
            v-if="activeTab !== 'links'"
            class="action-btn"
            type="button"
            :aria-label="$t('whatsapp.mediaDocsLinks.download')"
            @click="handleDownload()"
        >
          <img style="width: 20px;height: 20px" src="@/modules/whatsapp/img/download.png"/>
        </button>
      </div>
      <div v-if="showAllLink" class="footer-actions">
        <img style="width: 14px;height: 14px" src="@/modules/whatsapp/img/look.png"/>
        <span
            v-if="activeTab==='media'"
            class="action-link"
            role="button"
            tabindex="0"
            @click="handleOpenAll('media')"
        >{{ $t('whatsapp.mediaDocsLinks.viewAll.media') }}</span>
        <span
            v-else-if="activeTab==='docs'"
            class="action-link"
            role="button"
            tabindex="0"
            @click="handleOpenAll('docs')"
        >{{ $t('whatsapp.mediaDocsLinks.viewAll.docs') }}</span>
        <span
            v-else-if="activeTab==='links'"
            class="action-link"
            role="button"
            tabindex="0"
            @click="handleOpenAll('links')"
        >{{ $t('whatsapp.mediaDocsLinks.viewAll.links') }}</span>
      </div>
    </div>

    <ForwardMessage ref="forwardMessage" @send="handleForwardSend" @close="handleForwardClose" />
  </div>
</template>

<script>
import {isImageFile, isVideoFile} from "@/modules/whatsapp/utils/media-file";
import {Download, Document, Delete, Share} from "@element-plus/icons-vue";
import { ElMessageBox } from "element-plus";
import { addWhatsAppExtend, getWhatsAppExtendList, deleteWhatsAppExtendBatch, sendFile, sendImage, sendLinkCustomPreview, sendText } from "@/api/whatsapp.js";
import FileIcon from "@/components/File/FileIcon.vue";
import { downloadFile } from "@/utils/file";
import { Storage } from "@/utils/storage";
import 'viewerjs/dist/viewer.css'
import { api as viewerApi } from 'v-viewer'
import ForwardMessage from "@/views/WhatsApp/Compontents/ForwardMessage.vue";

export default {
  name: "MediaDocsLinksPanel",
  components: {Download, Document, Delete, Share, FileIcon, ForwardMessage},
  props: {
    defaultTab: {
      type: String,
      default: "media",
      validator: (v) => ["media", "docs", "links"].includes(v),
    },
    showAllLink: {
      type: Boolean,
      default: true,
    },
    chatId: {
      type: String,
      default: "",
    },
    isAllMode: {
      type: Boolean,
      default: false,
    },
    mediaList: {
      type: Array,
      default: () => [],
    },
    docsList: {
      type: Array,
      default: () => [],
    },
    linksList: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["preview-media", "delete", "forward", "download", "open-all", "update:activeTab"],
  data() {
    return {
      activeTab: this.defaultTab || "media",
      selectedKeysByTab: {
        media: [],
        docs: [],
        links: [],
      },
      forwardKeys: [],
      downloadLoading: false,
      scheduledLoadHandle: null,
      inFlightRequestKeys: {},
      scrollRafId: 0,
      attachments: {
        media: [],
        docs: [],
        links: []
      },
      pagination: {
        media: { page: 1, pageSize: 10, hasMore: true, loading: false },
        docs: { page: 1, pageSize: 10, hasMore: true, loading: false },
        links: { page: 1, pageSize: 10, hasMore: true, loading: false }
      }
    };
  },
  computed: {
    displayMediaList() {
      if (this.isAllMode || this.chatId) {
        return this.attachments.media.map((it, idx) => ({
          ...it,
          _key: it.id || it._id || `media_${idx}`,
        }));
      }
      if (this.mediaList.length > 0) {
        return this.mediaList.map((it, idx) => ({
          ...it,
          _key: it._id || it.id || `${idx}`,
        }));
      }
      return [
        {_key: "m1", type: "image/jpeg", url: "https://picsum.photos/400/400?random=1"},
        {_key: "m2", type: "image/jpeg", url: "https://picsum.photos/400/400?random=2"},
        {_key: "m3", type: "video/mp4", url: ""},
      ];
    },
    displayDocsList() {
      if (this.isAllMode || this.chatId) {
        return this.attachments.docs.map((it, idx) => ({
          ...it,
          _key: it.id || it._id || `docs_${idx}`,
          title: it.name || `Document ${idx + 1}`,
          sub: this.getFileSize(it.extendSize),
          text: it.url || '',
          time: this.formatTime(it.createTime)
        }));
      }
      if (this.docsList.length > 0) {
        return this.docsList.map((it, idx) => ({
          ...it,
          _key: it._key || it.id || `d${idx}`,
          time: it.time || this.formatTime(it.createTime)
        }));
      }
      return [
        {_key: "d1", title: this.$t('whatsapp.mediaDocsLinks.mock.docTitle', { index: 1 }), sub: "DOCX·18kb", text: this.$t('whatsapp.mediaDocsLinks.mock.text'), time: "12:30"},
        {_key: "d2", title: this.$t('whatsapp.mediaDocsLinks.mock.docTitle', { index: 2 }), sub: "DOCX·18kb", text: this.$t('whatsapp.mediaDocsLinks.mock.text'), time: "12:30"},
      ];
    },
    displayLinksList() {
      if (this.isAllMode || this.chatId) {
        return this.attachments.links.map((it, idx) => ({
          ...it,
          _key: it.id || it._id || `links_${idx}`,
          title: it.name || `Link ${idx + 1}`,
          sub: this.getLinkHost(it.url) || 'wa.mailtalk.com',
          text: it.url || ''
        }));
      }
      if (this.linksList.length > 0) {
        return this.linksList.map((it, idx) => ({...it, _key: it._key || it.id || `l${idx}`}));
      }
      return [
        {_key: "l1", title: this.$t('whatsapp.mediaDocsLinks.mock.linkTitle'), sub: "wa.mailtalk.com", text: this.$t('whatsapp.mediaDocsLinks.mock.text')},
        {_key: "l2", title: this.$t('whatsapp.mediaDocsLinks.mock.linkTitle'), sub: "wa.mailtalk.com", text: this.$t('whatsapp.mediaDocsLinks.mock.text')},
      ];
    },
  },
  watch: {
    activeTab() {
      this.$emit("update:activeTab", this.activeTab);
      this.scheduleEnsureTabLoaded();
    },
    defaultTab: {
      immediate: true,
      handler(val) {
        if (val && ["media", "docs", "links"].includes(val)) {
          this.activeTab = val;
        }
      },
    },
    chatId: {
      immediate: true,
      handler() {
        this.resetPanelState();
        this.scheduleResetAndLoad();
      }
    },
    isAllMode: {
      immediate: true,
      handler() {
        this.resetPanelState();
        this.scheduleResetAndLoad();
      }
    }
  },
  mounted() {
    this.scheduleEnsureTabLoaded();
  },
  methods: {
    resetPanelState() {
      this.selectedKeysByTab = {
        media: [],
        docs: [],
        links: [],
      };
      this.forwardKeys = [];
      this.downloadLoading = false;
      this.inFlightRequestKeys = {};
    },
    getSelectedKeys(tabType) {
      const t = tabType || this.activeTab;
      const list = this.selectedKeysByTab?.[t];
      return Array.isArray(list) ? list : [];
    },
    setSelectedKeys(tabType, keys) {
      const t = tabType || this.activeTab;
      this.selectedKeysByTab[t] = Array.isArray(keys) ? keys : [];
    },
    getDownloadFileName(item) {
      const baseName = String(item?.name || item?.title || '').trim();
      const url = item?.url || item?.extendUrl || item?.fileUrl || item?.path || item?.text || '';
      const ext = this.getFileExtFromNameOrUrl(baseName, url);
      const hasExt = baseName && baseName.includes('.') && baseName.split('.').pop();
      if (baseName) {
        if (hasExt) return baseName;
        if (ext) return `${baseName}.${ext}`;
        return baseName;
      }
      const timestamp = Date.now();
      return ext ? `attachment_${timestamp}.${ext}` : `attachment_${timestamp}`;
    },
    normalizeDownloadUrl(url) {
      const u = String(url || '').trim();
      if (!u) return '';
      return u.replace(/^http:\/\//i, 'https://');
    },
    getFileExtFromNameOrUrl(name, url) {
      const n = String(name || '').trim();
      if (n && n.includes('.')) {
        const ext = n.split('.').pop();
        return String(ext || '').toLowerCase();
      }
      const u = String(url || '').split('?')[0].split('#')[0].trim();
      if (!u) return '';
      const last = u.lastIndexOf('.');
      if (last === -1) return '';
      return u.slice(last + 1).toLowerCase();
    },
    isOfficePreviewableExt(ext) {
      const e = String(ext || '').toLowerCase();
      return ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'].includes(e);
    },
    scheduleResetAndLoad() {
      if (this.scheduledLoadHandle) {
        clearTimeout(this.scheduledLoadHandle);
      }
      this.scheduledLoadHandle = setTimeout(() => {
        this.scheduledLoadHandle = null;
        this.resetAndLoad();
      }, 0);
    },
    scheduleEnsureTabLoaded() {
      if (this.scheduledLoadHandle) {
        clearTimeout(this.scheduledLoadHandle);
      }
      this.scheduledLoadHandle = setTimeout(() => {
        this.scheduledLoadHandle = null;
        this.ensureTabLoaded();
      }, 0);
    },
    resetAndLoad() {
      this.resetPagination('media');
      this.resetPagination('docs');
      this.resetPagination('links');
      this.attachments.media = [];
      this.attachments.docs = [];
      this.attachments.links = [];
      this.ensureTabLoaded();
    },
    resetPagination(tabType) {
      if (!this.pagination[tabType]) return;
      this.pagination[tabType].page = 1;
      this.pagination[tabType].hasMore = true;
      this.pagination[tabType].loading = false;
    },
    ensureTabLoaded() {
      const tabType = this.activeTab;
      if (!this.isAllMode && !this.chatId) return;
      if (!['media', 'docs', 'links'].includes(tabType)) return;
      this.loadTabAttachments(tabType, true);
    },
    inferMimeTypeFromUrl(url) {
      const s = String(url || '').split('?')[0].split('#')[0].toLowerCase();
      const ext = s.includes('.') ? s.slice(s.lastIndexOf('.') + 1) : '';
      const imageExt = {
        png: 'image/png',
        jpg: 'image/jpeg',
        jpeg: 'image/jpeg',
        gif: 'image/gif',
        webp: 'image/webp',
        bmp: 'image/bmp',
        svg: 'image/svg+xml'
      };
      const videoExt = {
        mp4: 'video/mp4',
        webm: 'video/webm',
        mov: 'video/quicktime',
        m4v: 'video/x-m4v'
      };
      if (imageExt[ext]) return imageExt[ext];
      if (videoExt[ext]) return videoExt[ext];
      return '';
    },
    normalizeAttachmentItem(item) {
      let url = item?.url || item?.extendUrl || item?.fileUrl || item?.path || '';
      const rawType = item?.type || item?.extendType || item?.mimeType || item?.contentType;
      const type = typeof rawType === 'string' && rawType
        ? rawType
        : this.inferMimeTypeFromUrl(url);
      return {
        ...item,
        url,
        type
      };
    },
    isImage(file) {
      return file && isImageFile(file);
    },
    isVideo(file) {
      return file && isVideoFile(file);
    },
    thumbStyle(file) {
      const url = file?.url || file?.preview;
      if (!url) return {};
      return {backgroundImage: `url('${url}')`};
    },
    isSelected(key) {
      return this.getSelectedKeys().includes(key);
    },
    toggleSelect(key) {
      const keys = this.getSelectedKeys().slice();
      const idx = keys.indexOf(key);
      if (idx > -1) keys.splice(idx, 1);
      else keys.push(key);
      this.setSelectedKeys(this.activeTab, keys);
    },
    handleDeleteOne(key) {
      this.$emit("delete", {tab: this.activeTab, keys: [key]});
      this.setSelectedKeys(this.activeTab, this.getSelectedKeys().filter((k) => k !== key));
    },
    handleForwardOne(key) {
      this.$emit("forward", {tab: this.activeTab, keys: [key]});
    },
    getItemMessageId(item) {
      const it = item || {}
      return (
        it?.messageId ||
        it?.msgId ||
        it?.whatsAppMessageId ||
        it?.waMessageId ||
        it?.extendMessageId ||
        ''
      )
    },
    handleForwardClose() {
      this.forwardKeys = []
    },
    handleDelete() {
      const keys = this.getSelectedKeys().slice();
      if (keys.length === 0) {
        ElMessageBox.alert('请先勾选要删除的内容', '提示', {
          type: 'warning',
        });
        return;
      }
      
      ElMessageBox.confirm('确定要删除选中的项目吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const ids = keys.map(key => {
          const item = this.findItemByKey(key, this.activeTab);
          return item?.id || item?._id;
        }).filter(Boolean);
        
        if (ids.length === 0) {
          this.$message.error('无法获取要删除的项目ID');
          return;
        }

        deleteWhatsAppExtendBatch({ idList: ids })
          .then(() => {
            this.$message.success('删除成功');
            this.setSelectedKeys(this.activeTab, []);
            this.loadTabAttachments(this.activeTab, true);
          })
          .catch(() => {
            this.$message.error('删除失败');
          });
      }).catch(() => {
        // 用户取消删除
      });
    },
    handleForward() {
      const keys = this.getSelectedKeys().slice();
      if (keys.length === 0) {
        ElMessageBox.alert('请先勾选要转发的内容', '提示', {
          type: 'warning',
        });
        return;
      }
      this.forwardKeys = keys
      this.$refs?.forwardMessage?.open?.({ tab: this.activeTab, keys })
    },
    async handleForwardSend(payload) {
      const contacts = Array.isArray(payload?.contacts) ? payload.contacts : []
      const keys = Array.isArray(this.forwardKeys) ? this.forwardKeys : []
      const done = typeof payload?.done === 'function' ? payload.done : null
      if (!keys.length) {
        this.$message?.warning?.('请选择要转发的附件')
        done?.(false)
        return
      }
      if (!contacts.length) {
        this.$message?.warning?.('请选择联系人')
        done?.(false)
        return
      }

      const extractMessageId = (res) => {
        try {
          const payload0 = res?.result || res?.data?.result || res?.data || res || {}
          return String(
            payload0?._data?.id?._serialized ||
            payload0?.id?._serialized ||
            payload0?._data?.id ||
            payload0?.messageId ||
            payload0?.id ||
            payload0?._id ||
            ''
          )
        } catch (e) {
          return ''
        }
      }

      const resolveUserInfo = () => {
        try {
          const userInfo = Storage.get('userInfo') || {}
          const systemUserId = userInfo?.id || userInfo?.userId
          const userId = systemUserId ? String(systemUserId) : ''
          
          // 优先读取账号特定的 WhatsApp 登录信息
          let waUser = {}
          if (userId) {
            waUser = Storage.get(`wa_login_user_${userId}`) || {}
          }
          // 如果没有账号特定缓存，再读取通用缓存（兼容旧数据）
          if (!waUser || !waUser.id) {
            waUser = Storage.get('wa_login_user') || {}
          }
          
          return {
            userId,
            userName: String(waUser?.name || waUser?.pushName || waUser?.username || '')
          }
        } catch (e) {
          return { userId: '', userName: '' }
        }
      }

      const inferExtendType = (tab, mimetype) => {
        if (tab === 'links') return 3
        if (tab === 'docs') return 2
        const mt = String(mimetype || '').toLowerCase()
        if (mt.startsWith('image/') || mt.startsWith('video/') || mt.startsWith('audio/')) return 1
        return 2
      }

      const items = keys
        .map((k) => this.findItemByKey(k, this.activeTab))
        .filter(Boolean)

      const inferMimeFromUrl = (url) => {
        const u = String(url || '').split('?')[0].split('#')[0].toLowerCase()
        if (u.endsWith('.png')) return 'image/png'
        if (u.endsWith('.jpg') || u.endsWith('.jpeg')) return 'image/jpeg'
        if (u.endsWith('.gif')) return 'image/gif'
        if (u.endsWith('.webp')) return 'image/webp'
        if (u.endsWith('.bmp')) return 'image/bmp'
        if (u.endsWith('.svg')) return 'image/svg+xml'
        if (u.endsWith('.mp4')) return 'video/mp4'
        if (u.endsWith('.webm')) return 'video/webm'
        if (u.endsWith('.mov')) return 'video/quicktime'
        if (u.endsWith('.pdf')) return 'application/pdf'
        if (u.endsWith('.doc')) return 'application/msword'
        if (u.endsWith('.docx')) return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        if (u.endsWith('.xls')) return 'application/vnd.ms-excel'
        if (u.endsWith('.xlsx')) return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        if (u.endsWith('.ppt')) return 'application/vnd.ms-powerpoint'
        if (u.endsWith('.pptx')) return 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        if (u.endsWith('.csv')) return 'text/csv'
        if (u.endsWith('.txt')) return 'text/plain'
        if (u.endsWith('.zip')) return 'application/zip'
        if (u.endsWith('.rar')) return 'application/vnd.rar'
        return ''
      }

      const extFromUrl = (url) => {
        const u = String(url || '').split('?')[0].split('#')[0]
        const last = u.lastIndexOf('.')
        if (last === -1) return ''
        const ext = u.slice(last + 1)
        if (!ext || ext.includes('/') || ext.length > 10) return ''
        return ext
      }

      const buildFilename = (it, url) => {
        const name = String(it?.name || it?.title || '').trim()
        const url0 = String(url || it?.url || '').trim()
        const ext = extFromUrl(url0)
        if (name) {
          if (ext && !name.includes('.')) return `${name}.${ext}`
          return name
        }
        const urlPath = String(url0 || '').split('?')[0].split('#')[0]
        const last = urlPath.lastIndexOf('/')
        const base = last > -1 ? urlPath.slice(last + 1) : urlPath
        return base || (ext ? `file.${ext}` : 'file')
      }
      const buildMimetype = (it, url) => {
        const raw = String(it?.mimeType || it?.contentType || it?.type || '').trim()
        if (raw && raw.includes('/')) return raw
        return inferMimeFromUrl(url) || this.inferMimeTypeFromUrl(url) || 'application/octet-stream'
      }
      const session = 'default'
      try {
        const { userId, userName } = resolveUserInfo()
        const tasks = []
        contacts.forEach((c) => {
          const chatId = c?.id || c?.chatId
          if (!chatId) return

          items.forEach((it) => {
            if (this.activeTab === 'links') {
              const text = String(it?.text || it?.url || '').trim()
              if (!text) return
              const url0 = this.normalizeLinkUrl(text)
              tasks.push(
                (url0
                  ? sendLinkCustomPreview({
                    chatId,
                    linkPreviewHighQuality: true,
                    preview: {
                      description: text,
                      title: url0,
                      url: url0,
                    },
                    session,
                    text,
                  })
                  : sendText({
                    chatId,
                    linkPreview: true,
                    linkPreviewHighQuality: false,
                    session,
                    text,
                  })
                )
                  .then(async (res) => {
                    const messageId = extractMessageId(res)
                    if (!messageId) return { ok: false }
                    try {
                      await addWhatsAppExtend({
                        chatId: String(chatId || ''),
                        messageId,
                        name: text,
                        type: 3,
                        url: String(url0 || text || ''),
                        extendSize: 0,
                        userId,
                        userName,
                      })
                      return { ok: true }
                    } catch (e) {
                      this.$message?.warning?.(e?.message || '链接存储失败')
                      return { ok: false }
                    }
                  })
                  .catch(() => ({ ok: false }))
              )
              return
            }

            const url = String(it?.url || it?.extendUrl || it?.fileUrl || it?.path || '').trim()
            if (!url) return
            const filename = buildFilename(it, url)
            const mimetype = buildMimetype(it, url)
            const apiCall = typeof mimetype === 'string' && mimetype.startsWith('image/') ? sendImage : sendFile
            tasks.push(
              apiCall({
                caption: '',
                chatId,
                file: {
                  filename,
                  mimetype,
                  url,
                },
                session,
              })
                .then(async (res) => {
                  const messageId = extractMessageId(res)
                  if (!messageId) return { ok: false }
                  try {
                    await addWhatsAppExtend({
                      chatId: String(chatId || ''),
                      messageId,
                      name: String(filename || ''),
                      type: inferExtendType(this.activeTab, mimetype),
                      url: String(url || ''),
                      extendSize: Number(it?.extendSize || it?.size || 0),
                      userId,
                      userName,
                    })
                    return { ok: true }
                  } catch (e) {
                    this.$message?.warning?.(e?.message || '附件存储失败')
                    return { ok: false }
                  }
                })
                .catch(() => ({ ok: false }))
            )
          })
        })

        if (tasks.length === 0) {
          this.$message?.warning?.('缺少 chatId，无法转发')
          return
        }

        const results = await Promise.all(tasks)
        const successCount = (results || []).filter((r) => r.ok).length
        const failCount = (results || []).length - successCount
        if (successCount > 0 && failCount === 0) {
          this.$message?.success?.('转发成功')
          done?.(true)
        } else if (successCount > 0) {
          this.$message?.warning?.(`部分转发成功（成功 ${successCount}，失败 ${failCount}）`)
          done?.(false)
        } else {
          this.$message?.error?.('转发失败')
          done?.(false)
        }
      } catch (e) {
        done?.(false)
      } finally {
        this.forwardKeys = []
      }
    },
    async handleDownload(keysArg) {
      if (this.activeTab === 'links') return;
      const keys = keysArg || this.getSelectedKeys().slice();
      if (!keys || keys.length === 0) {
        this.$message?.warning?.('请选择要下载的附件');
        return;
      }

      if (this.downloadLoading) return;
      this.downloadLoading = true;
      try {
        for (const key of keys) {
          const target = this.findItemByKey(key, this.activeTab);
          const rawUrl = target?.url || target?.extendUrl || target?.fileUrl || target?.path || target?.text || '';
          const url = this.normalizeDownloadUrl(rawUrl);
          if (!url) {
            this.$message?.warning?.('下载链接为空');
            continue;
          }

          try {
            const res = await fetch(url);
            if (!res.ok) {
              throw new Error(`HTTP status: ${res.status}`);
            }
            const blob = await res.blob();
            const filename = this.getDownloadFileName(target);
            downloadFile(blob, filename);
          } catch (e) {
            console.error('下载失败:', e);
            this.$message?.error?.('下载失败');
          }
        }
      } finally {
        this.downloadLoading = false;
      }
    },
    handlePreviewMedia(item) {
      if (!item) return
      if (this.isImage(item)) {
        const list = Array.isArray(this.displayMediaList) ? this.displayMediaList : []
        const imageList = list.filter(it => this.isImage(it))
        const images = imageList
          .map(it => ({ src: it?.url || it?.preview || '' }))
          .filter(it => !!it.src)

        const clickedSrc = item?.url || item?.preview || ''
        const initialViewIndex = Math.max(0, images.findIndex(it => it.src === clickedSrc))
        if (images.length === 0) return

        viewerApi({
          images,
          options: {
            initialViewIndex,
          },
        })
        return
      }
      if (this.isVideo(item)) {
        this.$emit("preview-media", item);
      }
    },
    handlePreviewDoc(item) {
      const key = item;
      const target = this.findItemByKey(key);
      const url = target?.url || '';
      if (!url) {
        this.$message?.warning?.(this.$t('whatsapp.mediaDocsLinks.noData'));
        return;
      }

      const ext = this.getFileExtFromNameOrUrl(target?.name, url);
      if (this.isOfficePreviewableExt(ext)) {
        window.open(
          'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url)
        );
        return;
      }

      window.open(url);
    },
    handlePreviewLinks(item) {
      const target = typeof item === 'object' && item !== null
        ? item
        : this.findItemByKey(item, 'links');
      this.openLinkInNewTab(target);
    },
    extractFirstHttpUrl(input) {
      const str = String(input || '')
      if (!str) return ''
      const m1 = str.match(/https?:\/\/[\S]+/i)
      if (m1 && m1[0]) return String(m1[0]).replace(/[),.，。；;]+$/g, '')
      const m2 = str.match(/\b(?:www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?:\/[\S]*)?/)
      if (m2 && m2[0]) return String(m2[0]).replace(/[),.，。；;]+$/g, '')
      return ''
    },
    normalizeLinkUrl(url) {
      const s = String(url || '').trim();
      if (!s) return '';
      if (/^(javascript|data|vbscript):/i.test(s)) return '';
      if (/[\s]/.test(s)) return '';
      if (s.startsWith('http://') || s.startsWith('https://')) return s;
      const domainLike = /^[a-zA-Z0-9.-]+(?::\d+)?(?:\/.*)?$/.test(s);
      if (!domainLike) return '';
      return `https://${s}`;
    },
    getFaviconUrl(url) {
      const extracted = this.extractFirstHttpUrl(url)
      const normalized = this.normalizeLinkUrl(extracted || url);
      if (!normalized) return this.getFallbackFavicon();
      const host = this.getLinkHost(normalized);
      if (!host) return this.getFallbackFavicon();
      return `https://icons.duckduckgo.com/ip3/${host}.ico`;
    },
    getFallbackFavicon() {
      return 'data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22none%22%20stroke%3D%22%23999%22%20stroke-width%3D%222%22%3E%3Cpath%20d%3D%22M10%2013a5%205%200%200%200%207.54.54l3-3a5%205%200%200%200-7.07-7.07l-1.72%201.71%22/%3E%3Cpath%20d%3D%22M14%2011a5%205%200%200%200-7.54-.54l-3%203a5%205%200%200%200%207.07%207.07l1.71-1.71%22/%3E%3C/svg%3E';
    },
    handleFaviconError(e) {
      const el = e?.target;
      if (!el) return;
      const fallback = this.getFallbackFavicon();
      if (el.src === fallback) return;
      if (String(el.src || '').includes('icons.duckduckgo.com/ip3/')) {
        const u = String(el.src || '')
        const m = u.match(/\/ip3\/([^/]+)\.ico/i)
        const host = m && m[1] ? m[1] : ''
        if (host) {
          el.src = `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=64`
          return
        }
      }
      el.src = fallback;
    },
    openLinkInNewTab(item) {
      const target = item || {};
      const url = this.normalizeLinkUrl(target?.text || target?.url);
      if (!url) {
        this.$message?.warning?.(this.$t('whatsapp.mediaDocsLinks.noData'));
        return;
      }
      window.open(url, '_blank', 'noopener');
    },
    handleOpenAll(tab) {
      this.$emit("open-all", tab);
    },
    handleScroll(e) {
      if (!this.isAllMode && !this.chatId) return
      const tabType = this.activeTab
      if (!['media', 'docs', 'links'].includes(tabType)) return
      if (!this.pagination?.[tabType]?.hasMore) return
      if (this.pagination?.[tabType]?.loading) return
      const el = e?.target
      if (!el) return
      if (this.scrollRafId) return
      this.scrollRafId = window.requestAnimationFrame(() => {
        this.scrollRafId = 0
        if (!this.pagination?.[tabType]?.hasMore) return
        if (this.pagination?.[tabType]?.loading) return
        const remain = el.scrollHeight - el.scrollTop - el.clientHeight
        if (remain <= 60) {
          this.loadMore()
        }
      })
    },
    async loadTabAttachments(tabType, refresh = false) {
      if (!this.isAllMode && !this.chatId) return;
      if (!['media', 'docs', 'links'].includes(tabType)) return;

      if (refresh) {
        this.resetPagination(tabType);
        this.attachments[tabType] = [];
      }

      if (!this.pagination[tabType].hasMore || this.pagination[tabType].loading) return;

      const requestedPage = this.pagination[tabType].page
      const requestKey = JSON.stringify({
        tabType,
        isAllMode: !!this.isAllMode,
        chatId: this.chatId || '',
        page: requestedPage,
        pageSize: this.pagination[tabType].pageSize
      });
      if (this.inFlightRequestKeys[requestKey]) return;
      this.inFlightRequestKeys[requestKey] = true;

      this.pagination[tabType].loading = true;
      try {
        const params = {
          type: this.getTypeValue(tabType),
          page: requestedPage,
          pageSize: this.pagination[tabType].pageSize
        };

        if (!this.isAllMode && this.chatId) {
          params.chatId = this.chatId;
        }

        const response = await getWhatsAppExtendList(params);
        const payload = response?.result || response?.data?.result || response?.data || response;
        const list = payload?.records || payload?.list || payload?.rows || payload?.data || payload || [];
        const rawList = Array.isArray(list) ? list : [];
        const newList = rawList.map(this.normalizeAttachmentItem);

        const merged = [...(this.attachments[tabType] || []), ...newList];
        merged.sort((a, b) => {
          const ta = Number(a?.createTime || a?.updateTime || a?.timestamp || a?.ts || 0);
          const tb = Number(b?.createTime || b?.updateTime || b?.timestamp || b?.ts || 0);
          return tb - ta;
        });
        this.attachments[tabType] = merged;

        const total = Number(payload?.total ?? payload?.count ?? payload?.totalCount ?? 0)
        const pages = Number(payload?.pages ?? payload?.totalPages ?? payload?.pageCount ?? 0)

        if (pages > 0) {
          this.pagination[tabType].hasMore = requestedPage < pages
        } else if (total > 0) {
          this.pagination[tabType].hasMore = (this.attachments[tabType] || []).length < total
        } else {
          this.pagination[tabType].hasMore = newList.length === this.pagination[tabType].pageSize
        }

        if (this.pagination[tabType].hasMore) {
          this.pagination[tabType].page = requestedPage + 1
        }
      } catch (error) {
        console.error(`Failed to load ${tabType}:`, error);
      } finally {
        this.pagination[tabType].loading = false;
        delete this.inFlightRequestKeys[requestKey];
      }
    },
    loadMore() {
      const tabType = this.activeTab;
      if (!this.isAllMode && !this.chatId) return;
      if (!['media', 'docs', 'links'].includes(tabType)) return;
      if (!this.pagination[tabType].hasMore || this.pagination[tabType].loading) return;
      this.loadTabAttachments(tabType, false);
    },
    
    getTypeValue(tabType) {
      const typeMap = {
        media: 1,
        docs: 2,
        links: 3
      };
      return typeMap[tabType] || 1;
    },

    getLinkHost(url) {
      const s = String(url || '').trim();
      if (!s) return '';
      try {
        if (s.startsWith('http://') || s.startsWith('https://')) {
          return new URL(s).hostname;
        }
        return new URL(`https://${s}`).hostname;
      } catch (e) {
        return '';
      }
    },
    
    findItemByKey(key, tabType) {
      const t = tabType || this.activeTab;
      const typeMap = {
        media: this.displayMediaList,
        docs: this.displayDocsList,
        links: this.displayLinksList,
      };
      const list = typeMap[t] || [];
      return (Array.isArray(list) ? list : []).find(item => item._key === key);
    },
    
    formatTime(timestamp) {
      if (!timestamp) return '';
      let t = timestamp;
      if (typeof t === 'string') {
        const trimmed = t.trim();
        if (trimmed && /^\d+$/.test(trimmed)) {
          t = Number(trimmed);
        } else {
          const parsed = Date.parse(trimmed);
          if (!isNaN(parsed)) t = parsed;
        }
      }

      if (typeof t === 'number') {
        // 10位秒级时间戳 -> 毫秒
        if (t > 0 && t < 1e12) t = t * 1000;
      }

      const date = new Date(t);
      if (isNaN(date.getTime())) return '';

      const now = new Date();
      const isSameDay =
        date.getFullYear() === now.getFullYear() &&
        date.getMonth() === now.getMonth() &&
        date.getDate() === now.getDate();

      const hh = String(date.getHours()).padStart(2, '0');
      const mm = String(date.getMinutes()).padStart(2, '0');
      if (isSameDay) {
        return `${hh}:${mm}`;
      }
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${month}-${day} ${hh}:${mm}`;
    },
    
    getFileSize(size) {
      if (!size) return '未知大小';
      const kb = size / 1024;
      if (kb < 1024) {
        return `${kb.toFixed(0)}KB`;
      }
      const mb = kb / 1024;
      return `${mb.toFixed(1)}MB`;
    },
    
  },
};
</script>

<style lang="scss" scoped>
.media-docs-links-panel {
  position: relative;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
}

/* Tabs 样式 */
.panel-tabs {
  flex: 1;
  min-height: 0;
  display: flex;

  :deep(.el-tabs__header) {
    margin: 0;
    padding: 0 16px;
    border-bottom: none;
  }

  :deep(.el-tabs__nav-wrap::after) {
    display: none;
  }

  :deep(.el-tabs__active-bar) {
    background-color: #1890ff;
    height: 3px;
    border-radius: 2px;
  }

  :deep(.el-tabs__item) {
    font-size: 13px;
    color: #666;
    padding: 12px 16px;
    height: auto;
    line-height: 1.5;

    &.is-active {
      color: #1890ff;
      font-weight: 500;
    }

    &:hover {
      color: #1890ff;
    }
  }

  :deep(.el-tabs__content) {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 0;
  }

  :deep(.el-tab-pane) {
    height: 100%;
    min-height: 70vh;
  }
}

/* 滚动区域 */
.panel-scroll {
  height: calc(100vh - 185px);
  overflow-y: auto;
  padding: 16px;
  /* 不需要额外的底部padding，因为bottom-actions现在是文档流的一部分 */
}

/* 分组标题 */
.group-title {
  font-size: 12px;
  color: #999;
  margin-bottom: 12px;
  padding-left: 4px;
}

/* 媒体网格布局 - 与设计稿一致 */
.media-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-bottom: 16px;
}

.media-grid-item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 8px;
  overflow: hidden;
  background: #f5f5f5;
  cursor: pointer;
  content-visibility: auto;
  contain: layout style paint;

  &.selected {
    .media-thumb {
      box-shadow: 0 0 0 2px #1890ff;
    }
  }
}

.media-thumb-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
}

.media-checkbox {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 10;

  :deep(.el-checkbox__input) {
    .el-checkbox__inner {
      width: 14px;
      height: 14px;
      border-radius: 4px;
      background-color: rgba(255, 255, 255, 0.9);
      border-color: #d9d9d9;

      &::after {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
        border-width: 2px;
        width: 4px;
        height: 7px;
      }
    }

    &.is-checked .el-checkbox__inner {
      background-color: #1890ff;
      border-color: #1890ff;
    }
  }
}

.media-thumb {
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.thumb_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  border-radius: 8px;
  will-change: transform;
  transform: translateZ(0);
  backface-visibility: hidden;
  content-visibility: auto;
}

.thumb_video {
  background: #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: center;

  .play_icon {
    width: 48px;
    height: 48px;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
  }
}

.thumb_placeholder {
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 48px;
    height: 48px;
    opacity: 0.5;
  }
}

/* 提示文字 */
.tip-text {
  font-size: 12px;
  color: #999;
  margin: 16px 0 0;
  padding-left: 4px;
  text-align: center;
}

.loading-text {
  font-size: 12px;
  color: #999;
  margin: 16px 0 0;
  padding-left: 4px;
  text-align: center;
}

/* 底部操作栏 */
.bottom-actions {
  flex-shrink: 0;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  background: #fff;
  border-top: 1px solid #f0f0f0;
  padding: 12px 16px;
  z-index: 10;
}

.bottom-actions-main {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-bottom: 8px;
}

.action-btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: #f5f5f5;
  }

  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }
}

.footer-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  .action-link {
    font-size: 13px;
    color: #1890ff;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

/* 文档行 - 复选框在外面 */
.doc-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.doc-row__checkbox {
  flex-shrink: 0;

  :deep(.el-checkbox__input) {
    .el-checkbox__inner {
      width: 14px;
      height: 14px;
      border-radius: 4px;
      background-color: #fff;
      border-color: #d9d9d9;

      &::after {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
        border-width: 2px;
        width: 4px;
        height: 7px;
      }
    }

    &.is-checked .el-checkbox__inner {
      background-color: #1890ff;
      border-color: #1890ff;
    }
  }
}

/* 文档卡片样式 */
.doc-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  background: #fff;
  cursor: pointer;

  &:hover {
    background: #fafafa;
  }

  &.selected {
    background: #e6f9ed;
    border-color: #b3e8c4;
  }
}

.doc-card__icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.doc-w {
  font-size: 18px;
  font-weight: 700;
  font-family: Georgia, serif;
}

.doc-card__main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.doc-card__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.doc-card__title {
  font-size: 13px;
  font-weight: 500;
  color: #333;
}

.doc-card__sub {
  font-size: 12px;
  color: #999;
}

.doc-card__text {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
  margin-bottom: 4px;
}

.doc-card__meta {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.doc-card__time {
  font-size: 12px;
  color: #999;
}

.doc-card__download {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;

  svg {
    width: 20px;
    height: 20px;
  }

  &:hover {
    color: #1890ff;
  }
}

/* 链接行 */
.link-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 12px;
}

.link-row__checkbox {
  flex-shrink: 0;
  margin-top: 30px;

  :deep(.el-checkbox__input) {
    .el-checkbox__inner {
      width: 14px;
      height: 14px;
      border-radius: 4px;
      background-color: #fff;
      border-color: #d9d9d9;

      &::after {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
        border-width: 2px;
        width: 4px;
        height: 7px;
      }
    }

    &.is-checked .el-checkbox__inner {
      background-color: #1890ff;
      border-color: #1890ff;
    }
  }
}

.link-content {
  flex: 1;
  min-width: 0;
}

/* 链接卡片 */
.link-card {
  display: flex;
  gap: 12px;
  flex-direction: column;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  background: #fff;
  cursor: pointer;
  margin-bottom: 8px;

  &:hover {
    background: #fafafa;
  }

  &.selected {
    background: #e6f9ed;
    border-color: #b3e8c4;
  }
}

.link-card__icon {
  width: 35px;
  height: 35px;
  border-radius: 8px;
  background: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #999;

  .link-favicon {
    width: 30px;
    height: 30px;
    object-fit: contain;
    border-radius: 4px;
    display: block;
  }

  svg {
    width: 20px;
    height: 20px;
  }
}

.link-card__main {
  flex: 1;
  min-width: 0;
  margin-left: 5px;
}

.link-card__title {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}

.link-card__sub {
  font-size: 12px;
  color: #999;
}

.link-text {
  font-size: 13px;
  color: #666;
  line-height: 1.4;
  padding-left: 4px;
}
</style>
